<template>
  <v-dialog v-model="dialog" max-width="700px">
    <v-card>
      <v-stepper v-model="step" height="">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">
            画像選択
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="2">
            画像のリンク先を設定する
          </v-stepper-step>
          <v-divider></v-divider>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <WidgetImageUploader
              @set-picture-url="setPictureUrl"
              ref="widgetImageUploader"
            />
          </v-stepper-content>
          <v-stepper-content step="2" class='' style="height: 538px">
            <v-row class='mb-5'>
              <v-btn class='mt-5 ml-4 mr-0 mb-5 pl-2 pr-2' outlined @click="step = 1">＜ 画像選択に戻る</v-btn>
            </v-row>
            <v-row class='mb-5'>
              <v-img :src="imageUrl" max-height="300" max-width="450" contain></v-img>
            </v-row>
            <v-row class="ml-1">
              <v-text-field
                v-model="transferLink"
                type="url"
                :rules="[urlValidation]"
                hint="※ 画像をリンク化しない場合は、空白のまま画像挿入してください。"
                persistent-hint
                style="max-width: 400px"
              >
                <template v-slot:label>
                  <InputLabel labelName="画像のリンク先" :required="false" />
                </template>
              </v-text-field>
              <v-btn class='mt-3 ml-5' color="primary" @click="complete"> 画像挿入 </v-btn>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
import WidgetImageUploader from './WidgetImageUploader'
import formValidationUtils from '@/mixins/form_validation_utils'
import InputLabel from '@/components/commons/formParts/inputLabel'

export default {
  components: { WidgetImageUploader, InputLabel },
  mixins: [formValidationUtils],
  props: {
    addImageDialog: {
      type: Boolean,
      required: true
    }
  },
  data: () => {
    return {
      step: 1,
      imageUrl: '',
      transferLink: ''
    }
  },
  computed: {
    dialog: {
      get () {
        return this.$props.addImageDialog
      },
      set () {
        this.cancelAndReset()
      }
    }
  },
  methods: {
    setPictureUrl (path) {
      this.imageUrl = path
      this.step = 2
    },
    complete () {
      this.$emit('insert-image-and-link', this.imageUrl, this.transferLink)
      this.cancelAndReset()
    },
    cancelAndReset () {
      this.$emit('close-add-image-dialog')
      this.imageUrl = ''
      this.transferLink = ''
      this.step = 1
      this.$refs.widgetImageUploader.resetForm()
    }
  }
}
</script>

<style scoped></style>
